import { useCallback } from 'react';
import { useGetEmissorContractPdfMutation } from '../services/contractPdfApi';
export function useEmissorContractPdf() {
    const [trigger, { isLoading }] = useGetEmissorContractPdfMutation();
    const getContractPdf = useCallback((contractId) => trigger({ contractId }).unwrap(), [trigger]);
    return { getContractPdf, isLoading };
}
